// @ts-nocheck
import { createHandlerChainRunnerOptionalParameter, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const ClosePartFinderDrawer: Handler = props => {
    props.dispatch({
        type: "Store/Components/PartFinder/ClosePartFinderDrawer",
    });
};

export const chain = [ClosePartFinderDrawer];

const closePartFinderDrawer = createHandlerChainRunnerOptionalParameter(chain, {}, "ClosePartFinderDrawer");
export default closePartFinderDrawer;
